import { render, staticRenderFns } from "./app-date-picker-shortcuts.vue?vue&type=template&id=2ed2d178&scoped=true"
import script from "./app-date-picker-shortcuts.vue?vue&type=script&lang=js"
export * from "./app-date-picker-shortcuts.vue?vue&type=script&lang=js"
import style0 from "./app-date-picker-shortcuts.vue?vue&type=style&index=0&id=2ed2d178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2d178",
  null
  
)

export default component.exports